module.exports = __webpack_public_path__ + "img/arrow_right_2.237c9fb3.svg";